import { SHOW_LOGS } from "../config";

const dbg = SHOW_LOGS
 ? {
  log: (msg?: any, ...args: any[]) => console.log(`%c >>>${msg}`, 'color: #3498db', ...args),
  error: (msg?: any, ...args: any[]) => console.error(">>>", msg, ...args),
  trace: (msg?: any, ...args: any[]) => console.trace(">>>", msg, ...args),
  warn: (msg?: any, ...args: any[]) => console.warn(">>>", msg, ...args),
 } : {
  log: (msg?: any, ...args: any[]) => {},
  error: (msg?: any, ...args: any[]) => {},
  trace: (msg?: any, ...args: any[]) => {},  
  warn: (msg?: any, ...args: any[]) => {},  
 }

export default dbg;